import React, { useState, useEffect } from "react";

import { MessageStrip } from "@ui5/webcomponents-react/lib/MessageStrip";
import { MessageStripType } from "@ui5/webcomponents-react/lib/MessageStripType";
import "@ui5/webcomponents-icons/dist/icons/message-error.js";
import "@ui5/webcomponents-icons/dist/icons/message-information.js";
import "@ui5/webcomponents-icons/dist/icons/message-success.js";
import "@ui5/webcomponents-icons/dist/icons/message-warning.js";


const MessageStripCompnt = (props) => {
  const [closeStrip, setCloseStrip] = useState(false);
  const [type, setType] = useState(null);

  const onClose = () => {
    setCloseStrip(true);
  };

  useEffect(() => {
    const setVariables = (pType) => {
      switch (pType) {
        case "info":
          setType(MessageStripType.Information);
          break;
        case "error":
          setType(MessageStripType.Negative);
          break;
        case "success":
          setType(MessageStripType.Positive);
          break;
        case "warning":
          setType(MessageStripType.Warning);
          break;
        default:
          setType(null);
      }
    };
    
    setVariables(props.type);
  }, [props.type]);

  return (
    !closeStrip && (
      <MessageStrip
        className={props.className}
        type={type}
        noIcon={false}
        noCloseButton={false}
        onClose={onClose}
      >
        {props.message}
      </MessageStrip>
    )
  );
};

export default MessageStripCompnt;
